app.service('basketStandaloneService', function (modal, loading, broker) {
	function update(options) {
		loading.start();
		$.ajax({
			url: '/cart-update-partner-subscription-standalone-service-quantity.ltr',
			method: 'POST',
			dataType: 'json',
			data: {
				productId: options.productId,
				quantity: options.quantity,
				relatedPromotionIdentifier: options.relatedPromotionIdentifier
			},
			success: function (json) {
				loading.stop();
				if (json && json.status == 'FAIL') {
					modal.generate({
						id: 'standalone-service-message',
						content: '<p>' + json.messages + '</p>',
						callbackClose: function () {
							broker.trigger('REFRESH_BASKET_VIEW');
						},
						buttons: [
							{
								text: 'Rozumiem',
								click: function () {
									modal.close(false);
								},
								cssClass: 'btn btn-second',
							}
						]
					});
				} else {
					broker.trigger('REFRESH_BASKET_VIEW');
				}
			}, error: function () {
				loading.stop();
				modal.alert('Wystąpił błąd zmiany ilości. Spróbuj ponownie', function () {
					broker.trigger('REFRESH_BASKET_VIEW');
				});
			}
		});
	}
	return {
		update
	};
});
